'use client';

import { LoadingIndicator } from '@triumph/design-system';
import { FlexItemCenterDiv } from '../common.StyledComponents';
import { Container, Content, LoadingTextContainer } from './LoadingScreen.StyledComponents';

export const LoadingScreen = () => {
    return (
        <Container>
            <Content>
                <FlexItemCenterDiv>
                    <LoadingIndicator show />
                </FlexItemCenterDiv>
                <LoadingTextContainer data-testid="loading-text">Loading...</LoadingTextContainer>
            </Content>
        </Container>
    );
};
